import { SecureAction } from '../../secure-actions';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class AnalyticsAdvancedPlottingSecureAction extends SecureAction {
  public static readonly VIEW: SecureAction = new AnalyticsAdvancedPlottingSecureAction('device:analytics:advanced_plotting|view');

  private constructor(name: string) {
    super(name);
  }
}
